import React, { useState } from 'react';
import './Hero.css';

export default function Hero({ onOverviewOpen }) {
  const [pitchOpen, setPitchOpen] = useState(false);

  return (
    <section className="hero" id="hero">
      {/* Top decorative border */}
      <div className="hero__top-rule">
        <span className="hero__rule-line" />
        <span className="hero__rule-diamond" />
        <span className="hero__rule-line" />
      </div>

      <div className="hero__inner">
        {/* Eyebrow label */}
        <p className="section-label hero__eyebrow">Portfolio</p>

        {/* Name */}
        <h1 className="hero__name">
          <span className="hero__name-first">Dmitriy</span>
          <span className="hero__name-last">Filimonov</span>
        </h1>

        {/* Art deco divider */}
        <div className="hero__divider">
          <span className="hero__divider-line" />
          <span className="hero__divider-ornament">◆</span>
          <span className="hero__divider-line" />
        </div>

        {/* Tagline */}
        <p className="hero__tagline">
          Solutions Engineer
        </p>
        <p className="hero__sub-tagline">
          Full-Stack Engineering &nbsp;·&nbsp; Client-Facing Delivery
        </p>

        {/* Pitch toggle */}
        <button
          className="hero__pitch-toggle"
          onClick={() => setPitchOpen(o => !o)}
          aria-expanded={pitchOpen}
        >
          {pitchOpen ? 'Close' : 'Why Hire Me'} &nbsp;
          <span className={`hero__pitch-arrow ${pitchOpen ? 'hero__pitch-arrow--open' : ''}`}>▾</span>
        </button>

        {/* Expandable pitch */}
        <div className={`hero__pitch ${pitchOpen ? 'hero__pitch--open' : ''}`} aria-hidden={!pitchOpen}>
          <div className="hero__pitch-inner">
            {/* Paper header matching About stationery */}
            <div className="hero__pitch-head">
              <div className="hero__pitch-rule" />
              <p className="hero__pitch-kicker">CS&amp;E Graduate &nbsp;·&nbsp; UC Merced &nbsp;·&nbsp; 2026</p>
              <div className="hero__pitch-rule" />
            </div>
            <p className="hero__pitch-body">
              I bridge the technical and human sides of building software. On my most
              recent project I led a four-person team contracted by a commercial farm: I
              worked directly with the client to pin down what they actually needed,
              coordinated the build with my teammates, helped implement the final system,
              and presented it at our capstone conference in terms anyone in the room could
              follow. I understand what software can and cannot do, and I build with
              security in mind, from cryptographic systems to production hardening. I am
              looking for a Solutions Engineer role where technical depth and clear
              communication are the job.
            </p>
          </div>
        </div>

        {/* CTA buttons */}
        <div className="hero__cta">
          <a href="#projects" className="hero__btn hero__btn--primary">View Work</a>
          <a href="#contact" className="hero__btn hero__btn--secondary">Get In Touch</a>
          <button onClick={onOverviewOpen} className="hero__btn hero__btn--overview">Quick Overview</button>
          <a href="/Dmitriy_F_Resume.pdf" target="_blank" rel="noopener noreferrer" className="hero__btn hero__btn--resume">View Resume</a>
        </div>
      </div>

      {/* Bottom decorative border */}
      <div className="hero__bottom-rule">
        <span className="hero__rule-line" />
        <span className="hero__rule-diamond" />
        <span className="hero__rule-line" />
      </div>
    </section>
  );
}